import { useLocation, useNavigate } from 'react-router-dom'

type ChangeViewProps = {
  newView: string
}

export const useChangeView = (): ((_props: ChangeViewProps) => void) => {
  const navigate = useNavigate()
  const _location = useLocation()
  return ({ newView }: ChangeViewProps): void => {
    // console.log('[useChangeView] newView>>>>>>>>>>>>', newView)
    const routes: Record<string, string> = {
      teams: '/teams',
      nco: '/nco',
      projects: '/projects',
      seo: '/seo',
      mtb: '/mtb',
      optimizations: '/optimizations',
      deals: '/deals',
      organizations: '/organizations',
      contacts: '/contacts',
      leads: '/leads',
      teamtasks: '/teamtasks',
      campaignchecklists: '/campaignchecklists',
      ads: '/ads',
      dashboard: '/dashboard',
    }

    if (routes[newView]) {
      localStorage.setItem('boardSelectView', JSON.stringify(newView))
      navigate(routes[newView])
    } else {
      console.warn('Invalid view option:', newView)
    }
  }
}
